import { ShowDetails } from 'features/user/Show'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const ShowDetailsPage = () => {
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()

    useEffect(() => {
        if (!id) {
            navigate('/musor')
        }
    }, [id, navigate])

    return <>{id && <ShowDetails showId={id} />}</>
}
